export default class Company {
    constructor() {
        this.id = "";
        this.logo = "";
        this.person = {};
        this.contact = {};
        this.address = {};
    }
}